import React, { useState, useEffect } from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { H5, Image } from 'AbstractElements';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PostCommon from 'Component/Common/Form/Post';
import DropzoneCommon from 'Component/Common/Upload/Dropzone';
import { submitVoucher } from 'Services/Features/Voucher/Utils/voucherUtils';
import { setFormData, resetFormData } from 'Services/Features/Voucher/voucherSlice';
import CustomLoader from 'Component/Common/CustomLoader';
import Select from 'react-select';
import { formatPrice } from 'Component/DashboardQeza/Common/PriceUtils';
import DatePicker from 'react-datepicker';
import { format, parse } from 'date-fns';

const VoucherForm = ({ label }) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const [selectedTypeValue, setSelectedTypeValue] = useState(null);
    const [selectedVisibleValue, setSelectedVisibleValue] = useState(null);

    const data = useSelector(state => state.voucher.currentVoucher)
    console.log (data, 'data');
    const startUpload = useSelector(state => state.voucher.loading);

    const handleSuccess = () => {
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/treatment-voucher`);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(data, 'data');
        dispatch(submitVoucher({ ...data, successCallback: handleSuccess }))
    };

    const handleDiscard = (e) => {
        e.preventDefault();
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/treatment-voucher`);
    };

    const handleSelectChange = (selectedOption, fieldName, setSelectedValue) => {
        if (fieldName === 'type' && selectedOption?.value === 'percentage' && data.discount > 100) {
            // Reset discount kalau berubah ke percentage dan lebih dari 100
            dispatch(setFormData({ 'discount': '' }));
        }
        setSelectedValue(selectedOption); // Update state lokal
        dispatch(setFormData({ [fieldName]: selectedOption ? selectedOption.value : '' })); // Update Redux
    };


    useEffect(() => {
        if (data.type) {
            setSelectedTypeValue(typeOptions.find((item) => item.value === data.type));
        }
        if (data.is_public) {
            setSelectedVisibleValue(isPublicOptions.find((item) => item.value === data.is_public));
        }
        if (data.expired_at) {
            setStartDate(parse(data.expired_at, 'yyyy-MM-dd HH:mm:ss', new Date()));
        }
    }, [data.type, data.is_public, data.expired_at]);
    
    const handleChanges = (e) => {
        const { name, value } = e.target;
        dispatch(setFormData({ [name]: value }));
    }

    const handleChangeBanner = ({ meta, file }, status) => {
        if (status === 'done') {
            dispatch(setFormData({ 'banner': file }));
        } else if (status === 'removed') {
            dispatch(setFormData({ 'banner': null }));
        }
    };

    const handleNumericChange = (e, fieldName, type, handleChanges) => {
        const rawValue = e.target.value.replace(/\./g, ""); // Hilangkan titik
        let numericValue = parseInt(rawValue, 10);

        if (type === "percentage") {
            // Batasin antara 0 - 100 untuk persen
            if (numericValue < 0) numericValue = 0;
            if (numericValue > 100) numericValue = 100;
            dispatch(setFormData({ 'type': type }));
        } else if (type === "nominal") {
            // Pastikan nominal nggak bisa negatif
            if (numericValue < 0) numericValue = 0;
            dispatch(setFormData({ 'type': type }));
        }

        handleChanges({ target: { name: fieldName, value: numericValue ? numericValue : "" } });
    };


    const typeOptions = [
        { value: 'percentage', label: 'Percentage (%)' },
        { value: 'nominal', label: 'Nominal (Rp)' },
    ];

    const isPublicOptions = [
        { value: 1, label: 'Ya' },
        { value: 0, label: 'Tidak' },
    ];

    const [startDate, setStartDate] = useState(null);

    const handleChangeExpired = (date) => {
        setStartDate(date);
        console.log('date', date);
        dispatch(setFormData({ 'expired_at': format(date, 'yyyy-MM-dd HH:mm:ss') }));
    };


    return (
        <PostCommon title={label} handleSubmit={handleSubmit} handleDiscard={handleDiscard} >
            {startUpload && (
                <CustomLoader />
            )}
            <div>
                <Row className="mb-3">
                    <Col sm={4}>
                        <FormGroup className='mb-3'>
                            <Label for="validationName" style={{ fontWeight: 'bold' }}>Nama Voucher :</Label>
                            <Input
                                className="form-control"
                                id="validationName"
                                type="text"
                                name="name"
                                placeholder="Masukkan nama voucher..."
                                required=""
                                value={data.name}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={4}>
                        <FormGroup className='mb-3'>
                            <Label for="validationCode" style={{ fontWeight: 'bold' }}>Kode Voucher :</Label>
                            <Input
                                className="form-control"
                                id="validationCode"
                                type="text"
                                name="code"
                                placeholder="Masukkan kode voucher..."
                                required=""
                                value={data.code}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={4}>
                        <FormGroup className='mb-3'>
                            <Label for="validationQuota" style={{ fontWeight: 'bold' }}>Kuota Voucher :</Label>
                            <Input
                                className="form-control"
                                id="validationQuota"
                                type="text"
                                name="quota"
                                placeholder="Masukkan kuota voucher..."
                                required=""
                                onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                        e.preventDefault();
                                    }
                                }}
                                value={data.quota}
                                onChange={(e) => handleNumericChange(e, "quota", "nominal", handleChanges)}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={3} md={12} lg={12} className="d-flex flex-wrap justify-content-center">
                        <FormGroup className='mb-3'>
                            <Label for="validationExpired" style={{ fontWeight: 'bold' }}>Tanggal Kadaluarsa : </Label>
                            <Col>
                                <DatePicker className="form-control digits" showPopperArrow={false} selected={startDate} showTimeSelect timeCaption="Jam" dateFormat="dd/MM/yyyy HH:mm:ss" timeFormat="HH:mm" onChange={handleChangeExpired} />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col lg={12} className="d-flex flex-wrap justify-content-center">
                        <Col xs={12} md={6} lg={3} className="mx-3 mb-3">
                            <Label for="validationDiscountType" style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                                Tipe Diskon 
                            </Label>
                            <Select
                                options={typeOptions}
                                className="js-example-basic-single"
                                isMulti={false}
                                isClearable={false}
                                placeholder="Pilih tipe diskon..."
                                onChange={(option) => handleSelectChange(option, 'type', setSelectedTypeValue)}
                                value={selectedTypeValue}
                            />
                        </Col>
                        <Col xs={12} md={6} lg={3} className="mx-3 mb-3">
                            <Label for="validationDiscount" style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                                Diskon 
                            </Label>
                            <Input
                                className="form-control"
                                id="validationDiscount"
                                type="text"
                                name="discount"
                                placeholder={`Masukkan ${data.type === 'percentage' ? 'persentase' : 'nominal'} diskon...`}
                                required=""
                                onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                        e.preventDefault();
                                    }
                                }}
                                value={formatPrice(data.discount)}
                                onChange={(e) => handleNumericChange(e, "discount", data.type, handleChanges)}
                            />
                        </Col>
                        <Col xs={12} md={6} lg={3} className="mx-3 mb-3">
                            <Label for="validationis_public" style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                                Tampilkan
                            </Label>
                            <Select
                                options={isPublicOptions}
                                className="js-example-basic-single"
                                isMulti={false}
                                isClearable={false}
                                placeholder="Pilih status publik..."                                    
                                onChange={(option) => handleSelectChange(option, 'is_public', setSelectedVisibleValue)}
                                value={selectedVisibleValue}
                            />
                        </Col>
                    </Col>


                    {data.bannerLink ? (
                        <>
                            <Col sm="4" className="mb-3 mt-3">
                                <H5>Preview Banner Voucher</H5>
                                <Image
                                    attrImage={{
                                        className: 'img-fluid w-100',
                                        src: data.bannerLink,
                                        alt: `${data.name}`,
                                        style: {
                                            height: 'auto',
                                            width: '100%',
                                            maxWidth: '600px',
                                            objectFit: 'contain',
                                            borderRadius: '8px'
                                        }
                                    }}
                                />
                            </Col>
                            <Col sm="8" className="mb-3 mt-3">
                                <DropzoneCommon
                                    label={'Banner Voucher'}
                                    inputContent={'Update banner voucher'}
                                    handleChangeStatus={handleChangeBanner}
                                    accept="image/*"
                                    multiple={false}
                                    maxFiles={1}
                                />
                            </Col>
                        </>
                    ) : (
                        <Col sm="12" className="mb-3 mt-3 d-flex justify-content-center">
                            <Col sm="8">
                                <DropzoneCommon
                                    label={'Banner Voucher'}
                                    inputContent={'Upload banner voucher'}
                                    handleChangeStatus={handleChangeBanner}
                                    accept="image/*"
                                    multiple={false}
                                    maxFiles={1}
                                />
                            </Col>
                        </Col>
                    )}
                </Row>
            </div>
        </PostCommon>
    );
};

export default VoucherForm;